// extracted by mini-css-extract-plugin
module.exports = {"c-logo":"logo_c-logo__wd5Ll","-size-s":"logo_-size-s__FV2WF","-size-l":"logo_-size-l__Zvwe3"};